import { create } from 'zustand'

interface NoteDrawerState {
  todoId: string | null
  open: (id: string) => void
  close: () => void
}

export const useNoteDrawerStore = create<NoteDrawerState>((set) => ({
  todoId: null,
  open: (id) => set({ todoId: id }),
  close: () => set({ todoId: null }),
}))
